import { initializeApp } from 'firebase/app';
import { getPerformance as _getPerformance } from 'firebase/performance';
import { initializeAnalytics, setUserId as _setUserId, setDefaultEventParameters as _setDefaultEventParameters, logEvent, getGoogleAnalyticsClientId } from 'firebase/analytics';
/**
 * 初始化 firebase
 * @param config
 * @returns
 */
export const initFirebase = (config) => {
    const app = config
        ? initializeApp(config)
        : null;
    return app;
};
/**
 * 初始化性能监控
 * @param app
 * @returns
 */
export const getPerformance = (app) => {
    return _getPerformance(app);
};
/**
 * 初始化埋点实例
 * @param app
 */
export const getAnalytics = (app, options) => {
    return initializeAnalytics(app, options);
};
/**
 * 触发事件
 * @param app
 * @param event
 * @param params
 */
export const trackEvent = (app, event, params = {}) => {
    logEvent(app, event, params);
};
/**
 * 设置用户标识
 * @param app
 * @param userId
 */
export const setUserId = (app, userId) => {
    _setUserId(app, userId);
};
/**
 * 设置默认参数
 * @param app
 * @param userId
 */
export const setDefaultEventParameters = (params = {}) => {
    _setDefaultEventParameters(params);
};
/**
 * 获取 ga client id
 * @param app
 * @returns
 */
export const getGAClientId = (app) => {
    return getGoogleAnalyticsClientId(app);
};
